import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface TransacaoPagarmeModel {
    id: string
    status: string | null
    type: string | null
    total: number
    dataFormatada: string | null
    idPedido: number | null
    codigoTransacao: string | null
    balanceAmount: number | null
}

export interface ExtratoPagarmeResponse {
    transacoes: TransacaoPagarmeModel[]
    saldo: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterExtratoPagarme = async function (
    authorization: string,
    dataInicio: string,
    dataFim: string
): Promise<ExtratoPagarmeResponse | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ExtratoPagarmeResponse>>(
                `pagarme/ObterExtratoPagarme?dataInicio=${dataInicio}&dataFim=${dataFim}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ExtratoPagarmeResponse>(response, "ObterExtratoPagarme")
    } catch (error) {
        RegistrarLogErro(error, "ObterExtratoPagarme", `${dataInicio} - ${dataFim}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const estornarPixPagarme = async function (
    authorization: string,
    id: string
): Promise<{ mensagem: string } | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<{ mensagem: string }>>(
                `pagarme/EstornarPixPagarme/${id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ mensagem: string }>(response, "EstornarPixPagarme")
    } catch (error) {
        RegistrarLogErro(error, "EstornarPixPagarme", id)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
